import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import {path} from 'ramda'
import TextField from "../../Fields/Text";
import Button from "../../Navigation/Components/Button";
import {Map, Placemark, YMaps} from "react-yandex-maps";
import {Field} from "react-final-form";
import Loader from "../../Loader";
import {useTranslate} from "../../../helpers/translate";
import { YANDEX_API_KEY } from "../../Fields/Map/YandexMap";

const YandexWrap = styled.div`
    position: relative;
    margin-bottom: 20px;
`

const YandexCont = styled.div`
    overflow-x: hidden;
`

const YandexEdit = styled.div`
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
`

const Buttons = styled('div')`
    display: flex;
    align-items: center;
    gap: 10px;
`

const Grid = styled('div')`
    display: grid;
    grid-template-columns: repeat(3, 98px);
    gap: 5px;
`

const AddressField = props => {
  const {
    onIconClick,
    loading,
    locationInputs,
    isDetail,
    editAddress,
    values
  } = props

  const {t} = useTranslate()

  const coords = path(['value'], locationInputs)

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <YandexCont>
        {isLoading || loading
          ? (
            <Loader/>
          ) : (
            <>
              <YandexWrap>
                <YandexEdit>
                  <Button title={t('edit')} onClick={onIconClick} width={'150px'} type={'button'}/>
                </YandexEdit>
                <YMaps query={{apikey: YANDEX_API_KEY, lang: 'ru_RU'}} preload={true}>
                  <Map
                    height={'160px'}
                    width={'100%'}
                    modules={['geocode']}
                    defaultState={{center: [coords.lat, coords.lon], zoom: 15, controls: []}}
                  >
                    <Placemark
                      geometry={[coords.lat, coords.lon]}
                    />
                  </Map>
                </YMaps>
              </YandexWrap>
              <div>
                <Field
                  component={TextField}
                  placeholder={t('address')}
                  label={t('address')}
                  name={'name'}
                />
                <Grid>
                  <Field
                    component={TextField}
                    name={'entrance'}
                    placeholder={t('entrance')}
                    label={t('entrance')}
                    type={'tel'}
                  />
                  <Field
                    component={TextField}
                    name={'floor'}
                    placeholder={t('floor')}
                    label={t('floor')}
                    type={'tel'}
                  />
                  <div style={{ marginBottom: '16px' }}>
                    <Field
                      component={TextField}
                      name={'room'}
                      placeholder={t('apartment')}
                      label={t('apartment')}
                      type={'tel'}
                    />
                  </div>
                </Grid>
                <Field
                  component={TextField}
                  name={'comment'}
                  placeholder={t('comment')}
                  label={t('comment')}
                />
              </div>
            </>
          )
        }
        {isLoading || loading ? null : isDetail ? (
          <Buttons>
            <Button
              style={{
                marginTop: '20px',
              }}
              theme={'delete'}
              type={'submit'}
              loading={isLoading || loading}
              disabled={isLoading || loading}
              title={t('delete')}
            />
            <Button
              style={{
                marginTop: '20px',
              }}
              type={'click'}
              onClick={() => editAddress.onSubmit(values)}
              loading={isLoading || loading}
              disabled={isLoading || loading}
              title={t('edit')}
            />
          </Buttons>
        ) : (
          <Button
            style={{
              marginTop: '20px',
            }}
            type={'submit'}
            loading={isLoading || loading}
            disabled={isLoading || loading}
            title={t('add_address')}
          />
        )}
      </YandexCont>
    </>
  )
}

AddressField.propTypes = {
  onIconClick: PropTypes.func,
  input: PropTypes.any,
  withFloat: PropTypes.bool
}

export default AddressField
